import { render, staticRenderFns } from "./CompanyUsForm.vue?vue&type=template&id=744e228d&"
import script from "./CompanyUsForm.vue?vue&type=script&lang=js&"
export * from "./CompanyUsForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyUsForm.vue?vue&type=style&index=0&id=744e228d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports